module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 49
// module chunks = 0